export default __webpack_public_path__ + "static/animation_500_l0riblid-0f4d976d77d0007767cc78ae0810db84.gif";